export abstract class Tutorial {
	abstract trigger(action: string): void;
}

export function TutorialFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('Tutorial');
}

export const TutorialProvider = {
    provide: Tutorial,
    useFactory: TutorialFactory,
    deps: ['$injector']
};
